export const aprvlDisc = 'I approve going forward with the above checked repairs.'